module.exports = __webpack_public_path__ + "static/your-stylist-1eab5bb5f301d7b57f18d04f74e4d1ec.png";